import { MainPageLayout } from 'shared/components/MainPageLayout';
import { PresentationBlockContainer } from 'shared/containers/PresentationBlockContainer';
import { useFormSavedToast } from 'shared/hooks/useFormSavedToast';
import { MainContentContainer } from '../../MainContentContainer';

export const MainPage = () => {
  useFormSavedToast();

  return <MainPageLayout presentationBlock={<PresentationBlockContainer />} mainBlock={<MainContentContainer />} />;
};
